//import { HTTP } from '@/shared/http';
import sortParticipants from '@/shared/sortParticipants';
import { HTTP } from '@/shared/http';
import { mapState } from 'vuex';
import { editableMixin } from './EditableMixin';

export const modalParticipantMixins = {
         data() {
           return {
             currentUserParticipantIds: [],
             currentParticipant: null,
             existingParticipants: [],
           };
         },
         mixins: [editableMixin],
         computed: {
           ...mapState({
             participantBackup: (state) => state.poll.participantBackup,
           }),
           labelParticipateBtn() {
             return this.$t('participantModal.participateBtn');
           },

           invitation() {
             if (this.curInvitation && !this.curInvitation.participant_id) {
               return this.curInvitation;
             }
             return null;
           },
           isInvitedUser() {
             if (this.curInvitation) return true;
             return false;
           },
           showParticipateBtn() {
             // console.log(
             //   'showParticipateBtn:',
             //   this.isOwner,
             //   this.currentParticipant
             // );
             if (!this.isPollEditable) return false;
             if (this.isOwner) return false;
             return true;
             //if (this.currentParticipant) return false;
             //return true;
           },
         },
         methods: {
           getCurrentInvitation() {
             if (this.curInvitation && !this.curInvitation.participant_id) {
               return this.curInvitation.id;
             }
             return null;
           },

           sortCurrentUser(participants) {
             participants.sort((x, y) => {
               if (x.isCurrentUser) {
                 return -1;
               }
               if (y.isCurrentUser) {
                 return 1;
               }
               // if (x.isCurrentUserParticipant) {
               //   return -1;
               // }
               // if (y.isCurrentUserParticipant) {
               //   return 1;
               // }
               return 0;
             });
           },

           markAuthUserAsCurrent(pollParticipants) {
             let currentUserAssigned = false;
             const participants = pollParticipants.map((participant) => {
               if (this.userId && participant.user) {
                 participant.isCurrentUser =
                   this.userId === participant.user.id && !currentUserAssigned;
                 participant.isCurrentUserParticipant =
                   this.userId === participant.user.id;
                 if (this.userId === participant.user.id) {
                   currentUserAssigned = true;
                 }
               } else {
                 participant.isCurrentUser = false;
                 participant.isCurrentUserParticipant = false;
               }
               return participant;
             });
             return participants;
           },

           getUserParticipants() {
             const ls = localStorage.getItem('kulibri.participants');
             let myParticipants = [];

             if (ls) {
               myParticipants = JSON.parse(ls);
             }

             let poll = null;

             if (myParticipants) {
               poll = myParticipants.find((item) => item.poll == this.poll.id);
             }

             if (poll) {
               console.info(
                 'getLastParticipants -- lastParticipants:',
                 poll.participant
               );

               const invitation = this.poll.invitations.find(
                 (element) => element.id == poll.invitation
               );
               console.info('getLastParticipant -- invitation:', invitation);

               if (invitation) {
                 this.$store.commit('setInvitationId', poll.invitation);
                 this.$store.commit('setInvitation', invitation);
               }

               const participantsIds = myParticipants
                 .filter((item) => item.poll === this.poll.id)
                 .map((item) => item.participant);

               const participants = [];
               for (let id of participantsIds) {
                 const p = this.poll.participants.find((p) => p.id == id);
                 if (p != null) {
                   participants.push(p);
                 }
               }
               return participants;
             }
             const participant = localStorage.getItem('lastParticipant');
             return participant;
           },

           saveLastParticipant(participant) {
             //localStorage.setItem('lastParticipant', participant.id);
             let myParticipants = JSON.parse(
               localStorage.getItem('kulibri.participants') || '[]'
             );

             const curParticipant = {
               poll: this.poll.id,
               participant: participant.id,
               invitation: participant.invitation
                 ? participant.invitation.id
                 : null,
             };
             //const poll = myParticipants.find((item) => item.poll == this.poll.id);

             myParticipants.push(curParticipant);
             // if (!poll) {
             //   myParticipants.push(curParticipant);
             // } else {
             //   poll.participant = curParticipant.participant;
             //   poll.invitation = curParticipant.invitation;
             // }
             localStorage.setItem(
               'kulibri.participants',
               JSON.stringify(myParticipants)
             );
             console.info(
               'saveLastParticipant -- myParticipants:',
               myParticipants,
               curParticipant
             );
           },

           // find invited participant and if exists mark all participants with the same email as current
           findParticipantsWithSameEmail(participants) {
             if (this.curInvitation) {
               const invitedParticipant = participants.find(
                 (p) => p.id == this.curInvitation.participant_id
               );

               for (let p of participants) {
                 p.isCurrentUser = p.user_id === invitedParticipant.user_id;
               }
             }
             const currentParticipant = participants.find(
               (p) => p.isCurrentUser == true
             );

             if (currentParticipant) {
               for (let p of participants) {
                if (p.isCurrentUser) continue;
                  p.isCurrentUser =
                    p.user_id && p.user_id === currentParticipant.user_id;
               }
             }

             return participants;
           },

           identifyCurrentUser(pollParticipants) {
             // if the user is authenticated
             if (this.isAuthenticated) {
               participants = this.markAuthUserAsCurrent(pollParticipants);

               participants = this.findParticipantsWithSameEmail(participants);
               return participants;
             }

             if (this.isOwner) {
               participants = this.markAuthUserAsCurrent(pollParticipants);
               participants = this.findParticipantsWithSameEmail(participants);
               return participants;
             }

             let participants = null;
             // if invitation link is used for a added participant, this participant is the current user

             // check for last participant from local storage
             const userParticipants = this.getUserParticipants();
             let lastParticipant = null;
             if (userParticipants) {
               lastParticipant = userParticipants[0];
               lastParticipant.isCurrentUser = true;
               console.error(
                 'identifyCurrentUser lastParticipant:',
                 lastParticipant.name
               );
             }

             // if (this.isInvitedUser && this.curInvitation.participant_id) {
             //   console.log(
             //     'identifyCurrentUser - is invited user who is already  participating'
             //   );
             //   participants = this.poll.participants.map((participant) => {
             //     participant.isCurrentUser =
             //       participant.id === this.curInvitation.participant_id;
             //     if (this.user && participant.user) {
             //       participant.isCurrentUserParticipant =
             //         this.user.id === participant.user.id;
             //     }
             //     else {
             //       participant.isCurrentUserParticipant = false;
             //     }
             //     return participant;
             //   });
             //   return participants;
             // }

             // if the user is authenticated the logged in user is the current one

             participants = this.markAuthUserAsCurrent(pollParticipants);
             if (userParticipants) {
               for (let p of userParticipants) {
                 p.isCurrentUser = true;
               }
             }

             // find invited participant and if exists mark all participants with the same email as current
             participants = this.findParticipantsWithSameEmail(participants);
             if (this.isAuthenticated) {
               return participants;
             }
             console.error('identifyCurrentUser participant:', participants);
             return participants;
           },

           isNewParticipantRequired() {
             if (this.isPublicLink) return true;
             if (this.isInvitedUser && !this.curInvitation.participant_id) {
               return true;
             }
             return false;
           },

           getCurrentParticipant() {
             //console.log('currentParticipant from:', this.poll.participants);
             const current = this.poll.participants.find(
               (item) => item.isCurrentUser == true
             );
             return current;
           },

           enterNewParticipant() {
             console.log('Enter new participant');
             if (!this.isPollEditable) return;
             this.$refs.newParticipantModal.openModal();
           },

           onParticipate() {
             this.enterNewParticipant(true);
           },

           participationLinkSubject(creatorName) {
             let subject = '';
             if (this.isOwner) {
               subject = this.$t('invite.subjectText', {
                 userName: creatorName,
                 pollTitle: '„' + this.poll.title + '“',
               });
             } else {
               subject = this.$t('invite.subjectLink', {
                 userName: creatorName,
                 pollTitle: '„' + this.poll.title + '“',
               });
             }
             return subject;
           },

           participationLinkMessage(creatorName) {
             let message = '';
             if (this.isOwner) {
               message = this.$t('invite.messageText', {
                 userName: creatorName,
                 pollTitle: '„' + this.poll.title + '“',
                 email: this.poll.user.email,
                 pollUrl: '<Link>',
               });
             } else {
               message = this.$t('invite.messageLink', {
                 userName: creatorName,
                 pollTitle: '„' + this.poll.title + '“',
                 email: this.poll.user.email,
                 pollUrl: '<Link>',
               });
             }

             return message;
           },

           findParticipantWithEmail(participantEmail) {
             const email = participantEmail.toLowerCase();
             return this.poll.participants.find(
               (p) => p?.user?.email?.toLowerCase() == email
             );
           },

           async addEmailParticipant(participantData) {
             console.log('addEmailParticipant:', participantData);
             let creatorName = this.poll.user.name;

             const subject = this.participationLinkSubject(creatorName);
             const message = this.participationLinkMessage(creatorName);
             const message1 = this.$t('invite.messageStartNew');
             const locale = this.$i18n.locale;

             const invitationEmail =
               participantData.participantName +
               '<' +
               participantData.participantEmail +
               '>';
             let invitations = {
               id: this.poll.id,
               subject: subject,
               message: message,
               message1: message1,
               emails: invitationEmail,
               contacts: null,
               locale: locale,
               selfRegistration: true,
               pattributes: participantData.attributes,
               receiveCommentReminder: participantData.receiveCommentReminder,
               is_sub_admin: participantData.isSubAdmin,
             };

             this.$store.dispatch('sendInvitations', invitations).then(() => {
               console.log(
                 'onSaveModal -- Invitation was created and email send'
               );
               const participant = this.poll.participants.find((p) => {
                 if (!p.invitation) return false;
                 if (p.invitation.email !== participantData.participantEmail)
                   return false;
                 return p.name === participantData.participantName;
               });

               // store it as my participant with his invitation
               if (participant) {
                 this.saveLastParticipant(participant);
               }
               if (!this.isAuthenticated && !this.isAdminLink) {
                 if (participant) {
                   this.changeUrlToInvitationLink(participant);
                   participant.invitation.visited = true;
                   this.$store.dispatch(
                     'invitationVisit',
                     participant.invitation
                   );
                 }
               } else {
                 if (participant) {
                   if (participant.invitation.email && !this.isAdminLink) {
                     this.chnageUrlToPollLink();
                   }

                   if (participant.invitation.email === this.user.email) {
                     participant.invitation.visited = true;
                     this.$store.dispatch(
                       'invitationVisit',
                       participant.invitation
                     );
                   }
                 }
               }

               let participants = this.identifyCurrentUser(
                 this.poll.participants
               );
               sortParticipants(participants, this.userId);
               this.$store.commit('updateParticipants', participants);

               if (this.isOwner) return;
               // switch to enter mode after new participants was entered and if answer eitable

               this.currentParticipant = this.getCurrentParticipant();
               if (this.isAnswerEditable(this.currentParticipant)) {
                 this.submittingParticipant = this.currentParticipant;
                 const participantBackup = JSON.parse(
                   JSON.stringify(this.currentParticipant)
                 );
                 this.$store.commit('setParticipantBackup', participantBackup);
               }
             });
             return;
           },

           async addAnonymousParticipant(participantData) {
             let participant = {};
             participant.name = participantData.participantName;
             participant.email = participantData.participantEmail;
             participant.user_id = participantData.userId;
             participant.receive_comment_reminder =
               participantData.receiveCommentReminder;
             participant.show_admin_only = participantData.showAdminOnly;
             participant.invitation_id = this.getCurrentInvitation();
             participant.selfRegistration = this.isOwner ? false : true;
             participant.pattributes = participantData.attributes;
             participant.is_sub_admin = participantData.isSubAdmin;

             const newOwnerUser = participant.email ? true : false;

             const isUsingPublicLink = this.isPublicLink;

             console.log(
               'onSaveModal -- adding anonymous participant or participant with the owner email  :',
               participant
             );

             this.$store.dispatch('addParticipant', participant).then((res) => {
               console.log('onSaveModal -- Add Perticipant result:', res);
               const participant = res;

               this.updateCurrentInvitation(participant);
               let participants = null;
               if (!this.isAdminLink) {
                 this.chnageUrlToPollLink();
               }

               if (newOwnerUser) {
                 console.log('onSaveModal -- identify current users');
                 participants = this.identifyCurrentUser(
                   this.poll.participants
                 );
               } else {
                 // remember the new participant as the lastParticipant in the local storage

                 if (!this.isAuthenticated && !this.isAdminLink) {
                   // do not remove other from currentUser state
                   //this.markAuthUserAsCurrent(this.poll.participants);
                   participant.isCurrentUser = true;
                   this.curParticipant = 0;
                   this.displayCommentTaskNavigationPanel = false; // for the mobile when new participant register and in edit mode
                 }

                 this.saveLastParticipant(participant);
                 participants = this.poll.participants;
               }

               console.log(
                 'OnSaveModal list of active participants:',
                 participants
               );

               sortParticipants(participants, this.userId);
               this.getClassBasedOnChoice();
               // switch to enter mode if public link
               console.log(
                 'OnSaveModal : isUsingPublicLink',
                 isUsingPublicLink
               );
               if (isUsingPublicLink) {
                 this.currentParticipant = this.getCurrentParticipant();
                 if (this.isAnswerEditable(this.currentParticipant)) {
                   this.submittingParticipant = this.currentParticipant;
                   const participantBackup = JSON.parse(
                     JSON.stringify(this.currentParticipant)
                   );
                   this.$store.commit(
                     'setParticipantBackup',
                     participantBackup
                   );
                 }
               }
               this.$store.commit('updateParticipants', participants);
             });
           },

           async updateExistingParticipant(participantData) {
             // update participats attributes
             for (const attribute of participantData.attributes) {
               console.log(
                 'update attribute:',
                 attribute.name,
                 attribute.value
               );
               const a = this.editParticipant.attributes.find(
                 (e) => e.name == attribute.name
               );
               if (a) {
                 a.value = attribute.value;
               } else {
                 this.editParticipant.attributes.push({
                   name: attribute.name,
                   value: attribute.value,
                 });
               }
             }

             console.log('missing  attributes added:', this.editParticipant);
             this.editParticipant.name = participantData.participantName;
             this.editParticipant.receive_comment_reminder =
               participantData.receiveCommentReminder;
             this.editParticipant.show_admin_only =
               participantData.showAdminOnly;
             this.editParticipant.is_sub_admin = participantData.isSubAdmin;
             this.saveEditParticipant();
             this.modalEditMode = false;
           },

           async getExistingParticipants(email) {
             const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
             const url = apiUrl + '/participant/email/' + this.poll.id;
             let data = {};
             data.email = email;
             const result = await HTTP.post(url, data).catch((error) =>
               console.log(error)
             );

             if (!result || !result.data || !result.data.participants) {
               console.error('No participants returned from API');
               return [];
             }

             const participants = Array.isArray(result.data.participants)
               ? result.data.participants
               : [result.data.participants]; // Ensure it's an array

             console.info(
               'check if participant with this email and name already exist:',
               email,
               data,
               participants
             );
             return participants;
           },

           async onSaveModal(participantData) {
             this.participantData = participantData;
             if (participantData.participantEmail) {
               participantData.participantEmail = participantData.participantEmail.toLowerCase();
             }

             console.info('onSaveModal', participantData);

             // edit Mode
             if (this.modalEditMode) {
               this.updateExistingParticipant(participantData);
               return;
             }

             // get existing participant with the same email
             this.existingParticipants = await this.getExistingParticipants(
               participantData.participantEmail
             );

             // search for participant with the same name
             const existingParticipant = this.existingParticipants.find(
               (p) => p.name == participantData.participantName
             );

             // if exists switch to his url
             if (existingParticipant) {
               console.info('onSaveModal continue with existingParticipant');

               if (existingParticipant.invitation)
                 this.changeUrlToInvitationLink(existingParticipant);
               return;
             }

             console.info('onSaveModal no existingParticipant was found');

             // check for new non admin participant with email
             if (
               participantData.participantEmail &&
               participantData.participantEmail != this.poll.user.email
             ) {
               // if public link and participant with the same email exists
               if (
                 /* this.isPublicLink &&*/ this.existingParticipants.length > 0
               ) {
                 console.info(
                   'participant(s) with the same email already exist, let the user select ... ',
                   this.existingParticipants
                 );
                 // if new name -> ask the user if new should be created or he want to continue with existing obe
                 this.$refs.dlgParticipantsWithSameEmail.openModal();
                 return;
               }

               this.addEmailParticipant(participantData);
               return;
             }
             //
             this.addAnonymousParticipant(participantData);
           },

           startEditParticipant(participant) {
             console.log('startEditParticipant', this.isPollEditable);
             if (!this.isPollEditable) return;
             if (!this.isEditable(participant)) return;
             this.editParticipant = participant;
             this.modalEditMode = true;
             this.$refs.newParticipantModal.openModal();
           },

           saveEditParticipant() {
             this.$store.dispatch('updateParticipant', this.editParticipant);
             this.stopEditParticipant();
           },

           stopEditParticipant() {
             this.editParticipant = null;
             this.modalEditMode = false;
             // uncomment when need to redirect to dashboard
             // if(this.user == null) {
             //   window.location.href = 'https://kulibri.com';
             // } else {
             //   this.$router.push('/dashboard');
             // }
           },
           updateCurrentInvitation(participant) {
             console.log('Update current invitation');
             if (!this.curInvitation) return;
             console.log('Current invitation was updated');
             this.curInvitation.participant_id = participant.id;
           },

           changeUrlToInvitationLink(participant) {
             this.$store.commit('setIsPublicLink', false);
             this.$store.commit('setInvitation', participant.invitation);
             this.$store.commit('setInvitationId', participant.invitation.id);

             let participants = this.identifyCurrentUser(
               this.poll.participants
             );
             sortParticipants(participants, this.userId);
             this.$store.commit('updateParticipants', participants);

             const pathArray = window.location.pathname.split('/');
             const url =
               '/pr/' + pathArray[2] + '/' + participant.invitation.id;
             window.history.pushState({}, null, url);
           },

           chnageUrlToPollLink() {
             this.$store.commit('setIsPublicLink', false);
             const pathArray = window.location.pathname.split('/');
             const url = '/pr/' + pathArray[2];
             window.history.pushState({}, null, url);
           },
         },
       };
